export class SimuladorService {
  constructor() {}
  calcularValorParcela(plano, produto) {
    produto.valorParcela = produto.valor * produto.coeficiente;

    if (plano.modeloCobranca.periodicidade == "MENSAL") {
      produto.valorParcela = produto.valorParcela * 1;
    }
    if (plano.modeloCobranca.periodicidade == "TRIMESTRAL") {
      produto.valorParcela = produto.valorParcela * 3;
    }
    if (plano.modeloCobranca.periodicidade == "SEMESTRAL") {
      produto.valorParcela = produto.valorParcela * 6;
    }
    if (plano.modeloCobranca.periodicidade == "ANUAL") {
      produto.valorParcela = produto.valorParcela * 12;
    }

    if (produto.selecionado) {
      for (let x = 0; x < plano.produtos.length; x++) {
        let produtoVinculo = plano.produtos[x];
        if (produtoVinculo.idVinculoObrigatorio == produto.id) {
          produtoVinculo.selecionado = true;
        }
      }
    } else {
      for (let x = 0; x < plano.produtos.length; x++) {
        let produtoVinculo = plano.produtos[x];
        if (produtoVinculo.idVinculoObrigatorio == produto.id) {
          produtoVinculo.selecionado = false;
        }
      }
    }
    this.calcularValorMensal(plano);
  }

  formatPeriodicidade(periodicidade) {
    let periodicidadeLabel = "mês";

    if (periodicidade == "TRIMESTRAL") {
      periodicidadeLabel = "Trimestral.";
    }
    if (periodicidade == "SEMESTRAL") {
      periodicidadeLabel = "Semestral.";
    }
    if (periodicidade == "ANUAL") {
      periodicidadeLabel = "Anual";
    }

    return periodicidadeLabel;
  }

  calcularValorParcelas(plano) {
    for (let i = 0; i < plano.produtos.length; i++) {
      let produto = plano.produtos[i];
      this.calcularValorParcela(plano, produto);
    }
  }

  calcularValorMensal(plano) {
    plano.valorMensal = 0;
    if (plano.habilitarSimulacao) {
      for (let i = 0; i < plano.produtos.length; i++) {
        let produto = plano.produtos[i];
        if (produto.selecionado) {
          plano.valorMensal += produto.valorParcela;
        }
      }
    } else {
      plano.valorMensal = plano.modeloCobranca.valorPlano;
    }
  }
}
